/** Chef service materials are visible alongside existing food containers.
 * Existing food-container labels and photos remain visible.
 * Presentation only: never use this flag to change menus, shipment quantities,
 * school requirements, or pricing. Release candidate: merge only after rollout approval.
 */
export const CHEF_SERVICE_MATERIALS_VISIBLE: boolean = true

export function chefVisiblePrintLines<T extends { id: string; isSupply?: boolean }>(lines: ReadonlyArray<T>): T[] {
  return lines.filter((line) => CHEF_SERVICE_MATERIALS_VISIBLE || line.isSupply !== true)
}
